import {SnackbarNotification} from '../../../shared/components/snackbar/model';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';

export interface SnackbarState {
  notifications: SnackbarNotification[];
}

const initialState: SnackbarState = {
  notifications: [],
};

export const snackbarSlice = createSlice({
  name: '@@eskso/snackbar',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<SnackbarNotification[]>) => {
      return {
        ...state,
        notifications: action.payload,
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const snackbar = snackbarSlice.reducer;
